/* eslint-disable no-unused-vars */
export enum UserTypes {
    INTERNAL_USER = 'INT',
    END_USER_NEED_CONFIRM = 'END',
    PARTNER_USER_NEED_CONFIRM = 'PRT',
}
